module.exports = __webpack_public_path__ + "img/10_b2b_rainmaker.199e7a71.png";